<template>
  <vc-date-picker
    v-model="range"
    :model-config="modelConfig"
    is-range
  >
    <template #default="{ inputValue, inputEvents }">
      <div class="flex justify-center items-center">
        <input
          :value="inputValue.start"
          class="border px-1 pb-1 w-32 rounded focus:outline-none focus:border-indigo-300"
          v-on="inputEvents.start"
        >
        -
        <input
          :value="inputValue.end"
          class="border px-1 pb-1 w-32 rounded focus:outline-none focus:border-indigo-300"
          v-on="inputEvents.end"
        >

        <button
          class="btn btn-primary btn-sm"
          @click="$emit('update-date-range', range.start, range.end)"
        >
          Filter
        </button>
      </div>
    </template>
  </vc-date-picker>
</template>

<script>
import moment from "moment-timezone";

export default {
    name: "PaymentRequestDateFilter",
    props: {
        startDate: {
            type: String,
            required: false,
            default: ''
        },
        endDate: {
            type: String,
            required: false,
            default: ''
        },
    },
    data: function(){
        return {
            range: {
                start: (this.startDate !== '' && moment(this.startDate).isBefore(moment(this.endDate))) ? this.startDate : moment().startOf('month').format('YYYY-MM-DD'),
                end: (this.endDate !== '' && moment(this.endDate).isAfter(moment(this.startDate))) ? this.endDate : moment().endOf('month').format('YYYY-MM-DD')
            },
            modelConfig: {
                end: {
                    timeAdjust: '23:59:59',
                },
            }
        }
    }
}
</script>
